var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import FiberManualRecordOutlinedIcon from "@mui/icons-material/FiberManualRecordOutlined";
import { Box, IconButton, useTheme } from "@mui/material";
import "react-multi-carousel/lib/styles.css";
/**
 * CustomLeftArrow - Left arrow for the ItemCard slider with custom style and position.
 * Additional transform positions the arrow between the Item Cards.
 * @param props - onClick, arrowBgColor, arrowColor, additionalTransform
 * @returns
 */
export const CustomLeftArrow = (_a) => {
    var props = __rest(_a, []);
    const { onClick, arrowBgColor, borderColor, arrowColor } = props;
    return (_jsx(Box, Object.assign({ sx: Object.assign({ position: "absolute", left: 1, top: "50%" }, props.sx), display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", onClick: () => onClick() }, { children: _jsx(IconButton, Object.assign({ size: "small", sx: { backgroundColor: arrowBgColor, border: `2px solid ${borderColor}` } }, { children: _jsx(ChevronLeftIcon, { fontSize: "medium", sx: { color: arrowColor } }) })) })));
};
/**
 * CustomRightArrow - Right arrow for the ItemCard slider with custom style and position.
 * Additional transform positions the arrow between the Item Cards.
 * @param props - onClick,carouselState, arrowBgColor, arrowColor, additionalTransform
 * @returns
 */
export const CustomRightArrow = (_a) => {
    var props = __rest(_a, []);
    const { onClick, arrowBgColor, borderColor, arrowColor } = props;
    return (_jsx(Box, Object.assign({ style: Object.assign({ position: "absolute", right: 1, top: "50%" }, props.sx), display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", onClick: () => onClick() }, { children: _jsx(IconButton, Object.assign({ size: "small", sx: { backgroundColor: arrowBgColor, border: `2px solid ${borderColor}` } }, { children: _jsx(ChevronRightIcon, { fontSize: "medium", sx: { color: arrowColor } }) })) })));
};
/**
 * CustomDot - Custom page dot using MaterialUI components
 * @param props - onClick, active
 * @returns
 */
export const CustomDot = (_a) => {
    var props = __rest(_a, []);
    const { onClick, active } = props;
    return (_jsx(IconButton, Object.assign({ disableFocusRipple: true, disableRipple: true, disableTouchRipple: true, onClick: () => onClick(), style: {
            backgroundColor: "transparent",
            marginBottom: "2rem",
        }, size: "large" }, { children: active ? _jsx(FiberManualRecordIcon, {}) : _jsx(FiberManualRecordOutlinedIcon, {}) })));
};
/**
 * Custom arrow for Slick slider. Uses a Mui icon and applies primary branding color.
 *
 * @param props
 * @returns
 */
export const SlickArrow = (props) => {
    const { className, style, onClick, type } = props;
    const theme = useTheme();
    const Icon = type === "next" ? ChevronRightIcon : ChevronLeftIcon;
    return (_jsx(Icon, { className: className, style: Object.assign(Object.assign({}, style), { display: onClick ? "block" : "none", color: theme.palette.primary.main, height: theme.spacing(3.5), width: theme.spacing(3.5) }), onClick: onClick }));
};
